import { Search, AlertTriangle, X } from "lucide-react";
import { TASK_STATUSES, PRIORITIES } from "@/lib/taskConstants";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const FilterBar = ({ filters, setFilters, members }) => {
  const set = (k, v) => setFilters((f) => ({ ...f, [k]: v }));
  const hasFilters = filters.q || filters.assignee !== "all" || filters.status !== "all" ||
    filters.priority !== "all" || filters.overdue;

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="task-filter-bar">
      <div className="relative">
        <Search className="h-3.5 w-3.5 absolute left-2.5 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <Input data-testid="filter-search-input" value={filters.q} onChange={(e) => set("q", e.target.value)}
          placeholder="Buscar tareas..." className="pl-8 h-8 w-44 text-sm" />
      </div>
      <Select value={filters.assignee} onValueChange={(v) => set("assignee", v)}>
        <SelectTrigger className="h-8 w-40 text-xs" data-testid="filter-assignee-select">
          <SelectValue placeholder="Responsable" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todos los responsables</SelectItem>
          <SelectItem value="unassigned">Sin responsable</SelectItem>
          {members.map((m) => (
            <SelectItem key={m.profile_id} value={m.profile_id}>{m.name}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select value={filters.status} onValueChange={(v) => set("status", v)}>
        <SelectTrigger className="h-8 w-36 text-xs" data-testid="filter-status-select">
          <SelectValue placeholder="Estado" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todos los estados</SelectItem>
          {TASK_STATUSES.map((s) => (
            <SelectItem key={s.value} value={s.value}>{s.label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select value={filters.priority} onValueChange={(v) => set("priority", v)}>
        <SelectTrigger className="h-8 w-36 text-xs" data-testid="filter-priority-select">
          <SelectValue placeholder="Prioridad" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Toda prioridad</SelectItem>
          {PRIORITIES.map((p) => (
            <SelectItem key={p.value} value={p.value}>{p.label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Button variant={filters.overdue ? "default" : "outline"} size="sm" className="h-8 text-xs"
        data-testid="filter-overdue-toggle" onClick={() => set("overdue", !filters.overdue)}>
        <AlertTriangle className="h-3.5 w-3.5 mr-1" /> Vencidas
      </Button>
      {hasFilters && (
        <Button variant="ghost" size="sm" className="h-8 text-xs text-muted-foreground" data-testid="filter-clear-btn"
          onClick={() => setFilters({ q: "", assignee: "all", status: "all", priority: "all", overdue: false })}>
          <X className="h-3.5 w-3.5 mr-1" /> Limpiar
        </Button>
      )}
    </div>
  );
};
